module.exports = __webpack_public_path__ + "img/oneClickBeautyTransformation01.f8aae6c4.png";